import React from 'react'
import { Route, Switch, withRouter } from 'react-router-dom'

import NotFound from 'components/common/NotFound'
import CrushProfileContainer from 'components/profile/CrushProfileContainer'
// import MyProfileContainer from 'components/profile/MyProfileContainer'
import StoredDataContainer from 'components/profile/StoredDataContainer'
// import LikeDislikeContainer from 'components/likedislike/LikeDislikeContainer'
import MatchesContainer from 'components/matches/MatchesContainer'
import SettingsContainer from 'components/settings/SettingsContainer'
import LoginContainer from 'components/login/LoginContainer'

const SUPPORT_URL = 'https://match.appstore01.com/delay/?tpcampid=038468af-7242-4a0e-9c1e-70f951645dd7'
// const SUPPORT_URL_FB = 'https://match.appstore01.com/delayfb/?tpcampid=038468af-7242-4a0e-9c1e-70f951645dd7'

/**
 * The Root Router for the App. It decides which View to render based on the
 * current path.
 */
const Router = () => {
  return (
    <Switch>
      {/* <Route path="/likedislike" component={LikeDislikeContainer} /> */}
      {/* <Route path="/profile" component={MyProfileContainer} /> */}
      <Route path="/likedislike" render={() => {
        // const openUrl = Math.random() < 0.5 ? SUPPORT_URL : SUPPORT_URL_FB
        const openUrl = SUPPORT_URL
        const url = openUrl + `&subPublisher=modal-psid`
        // window.open(url)
        window.location.href = url
        // window.location.href = 'https://www.google.com'
        return <div>nothing to see here</div>
      }} />
      <Route path="/profile" render={() => {
        // const openUrl = Math.random() < 0.5 ? SUPPORT_URL : SUPPORT_URL_FB
        const openUrl = SUPPORT_URL
        const url = openUrl + `&subPublisher=modal-psid`
        // window.open(url)
        window.location.href = url
        // window.location.href = 'https://www.google.com'
        return <div>nothing to see here</div>
      }} />
      <Route path="/stored-data" component={StoredDataContainer} />
      <Route path="/user-profile/:id" component={CrushProfileContainer} />
      <Route path="/matches" component={MatchesContainer} />
      <Route path="/settings" component={SettingsContainer} />
      <Route path="/login" component={LoginContainer} />
      <Route path="/error" render={() => {
        window.location.href = 'https://www.google.com'
        return <div>nothing to see here</div>
      }} />
      <Route
        path="/match-profile/:id"
        render={() => <CrushProfileContainer isMatch />}
      />
      <Route component={NotFound} />
    </Switch>
  )
}

export default withRouter(Router)



// WEBPACK FOOTER //
// ./src/components/app/Router.js